<template>
  <el-dialog
          :title="dialogtitle"
          :visible.sync="dialogVisible"
          @close="$emit('update:visible',false)"
          :close-on-click-modal="false"
  >
    <div class="dialog_conwrap">
      <div class="search_query">
        <el-input placeholder="请输入内容" v-model="name">
          <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
        </el-input>
      </div>
      <div class="namelist">
        <div
                v-for="(item,index ) in employeelist"
                :key="index"
                class="nameitem"
                :class="{ active:currentitem&&item.id===currentitem.id}"
                @click="chooseemployee(item)"
        >
          <span>{{item.name}}</span>
          <i class="checkname el-icon-check"></i>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
  import api from "@/api.js";

  export default {
    name: "chooseEmployeeDialog",
    props: ["visible", "dialogtitle", "type"],
    watch: {
      visible() {
        this.dialogVisible = this.visible;
      }
    },
    data() {
      return {
        dialogVisible: this.visible,
        name: "",
        currentitem: null,
        employeedata: [],
        employeelist: []
      };
    },
    created() {
      this.queryemployeelist();
    },
    methods: {
      // 查询员工详情
      queryemployeelist() {
        let params = {};
        this.axios
            .post(api.handover_list, params)
            .then(response => {
              if (response.data.code == 0) {
                this.employeedata = response.data.list || [];
                this.employeelist = [...this.employeedata];
              } else {
              }
            })
            .catch(response => {
            });
      },
      // 搜索
      search() {
        let result = [];
        this.employeedata.forEach(item => {
          if (item.name.indexOf(this.name) !== -1) {
            result.push(item);
          }
        });
        this.employeelist = result;
      },
      // 选择员工
      chooseemployee(item) {
        this.currentitem = item;
      },
      // 确认
      save() {
        // "ai_radar":"名片状态(0关闭、1开启)",
        if (this.currentitem.ai_radar == 1 && this.type == 'H') {
          this.$confirm('请先将交出方-'+this.currentitem.name+'的名片禁用，否则不能继续进行工作交接', '工作交接', {
            confirmButtonText: '去修改',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$router.push('roles')
          }).catch(() => {
          });
          return
        }
        if (this.currentitem) {
          this.$emit("checkedemployee", this.currentitem, this.type);
        }
        this.dialogVisible = false;
      }
    }
  };
</script>


